import _ from "lodash";
import { mapActions, mapGetters } from "vuex";
import * as CONFIG from "@/config.js";

/* Create mapActions and mapGetters for a RestModule (and similar modules)
for Code Modules. And loads them!

moduleList is an array of Module names but assume moduleList has the value
['Test']

Then the following actions and getters are created

mapActions({
    createNewTest: 'TestModule/createNew',
    saveTestItem: 'TestModule/saveItem',
    getTestById: 'TestModule/getById',
    patchTestItem: 'TestModule/pathItem',

    getAllTest: 'TestModule/getAll', //called by loadCodeTables and when created
});

mapGetters({
    optionTestItems: 'TestModule/code_items',
    optionTestItems: 'TestModule/code_itemsByID',
    optionTestWorking: 'TestModule/working',
    optionTestItemsById: 'TestModule/itemsByID',
});
 */

export default function (moduleList, list_options) {
    var actionList = {};
    var fetchActionList = {};
    var getterList = {};

    var defaultLimit = CONFIG.DEFAULT_CODE_LIMIT || 2000;
    var defaultListOptions = list_options || {
        limit: defaultLimit,
        offset: 0,
        _code: true,
    };

    _.each(moduleList, function (moduleName) {
        var theModuleName = moduleName;
        if (typeof moduleName === "object" && moduleName.MODULE_NAME) {
            theModuleName = moduleName.MODULE_NAME;
        }

        actionList["createNew" + theModuleName] = theModuleName + "Module/createNew";
        actionList["save" + theModuleName + "Item"] =
            theModuleName + "Module/saveItem";
        actionList["get" + theModuleName + "ById"] = theModuleName + "Module/getById";
        actionList["patch" + theModuleName + "Item"] =
            theModuleName + "Module/patchItem";

        fetchActionList["getAll" + theModuleName] = theModuleName + "Module/getAll";

        getterList["option" + theModuleName + "Items"] =
            theModuleName + "Module/code_items";
        getterList["option" + theModuleName + "ItemsById"] =
            theModuleName + "Module/code_itemsByID";
        getterList["option" + theModuleName + "Working"] =
            theModuleName + "Module/working";
        getterList["get" + theModuleName + "NewItem"] = theModuleName + "Module/item";
    });

    /* With a Module name of "Customer" create a Method GetCustomerCodeList(list_options)
       That can be called to load the code options
     */

    var getCodeTablesMethods = {};
    _.each(moduleList, function (moduleName) {
        var theModuleName = moduleName;
        var specified_list_options = {}
        if (typeof moduleName === "object" && moduleName.MODULE_NAME) {
            theModuleName = moduleName.MODULE_NAME;
            specified_list_options = moduleName; // use these list options
        }

        var function_name = "Get" + theModuleName + "CodeList";

        getCodeTablesMethods[function_name] = function (list_options) {
            var vm = this;

            list_options = {
                _code: true /* this could be overwritten below*/,
                ...defaultListOptions,
                ...list_options,
                ...specified_list_options,
            }; // Get 2000 items - should be all if not we need to use another method
            var onBeforeFilterList = vm["OnBefore" + function_name];
            var onAfterFilterList = vm["OnAfter" + function_name];

            if (onBeforeFilterList) onBeforeFilterList(list_options);
            vm["getAll" + theModuleName]({ ...list_options }).then(function (
                results
            ) {
                if (onAfterFilterList) {
                    onAfterFilterList(results);
                }
            });
        };
    });

    return {
        methods: {
            ...getCodeTablesMethods,
            loadCodeTables() {
                const vm = this;

                console.log(
                    "This code is using 'CreateCodeTableFetchMixin' please replace with 'UseCodeModulesMixin' on the 'component' and 'FetchCodeMixin' for the 'Page' components. Use Builder to generate"
                );

                // Load all
                _.each(moduleList, function (moduleName) {
                    var theModuleName = moduleName;
                    if (typeof moduleName === "object" && moduleName.MODULE_NAME) {
                        theModuleName = moduleName.MODULE_NAME;
                    }
                    vm["Get" + theModuleName + "CodeList"]();
                });
            },
            ...mapActions({ ...fetchActionList, ...actionList }),
        },
        computed: {
            ...mapGetters(getterList),
            ...mapGetters("AuthModule", { _isLoggedIn: "isLoggedIn" }),
        },
        created() {
            if (this._isLoggedIn) {
                this.loadCodeTables();
            } else {
                var unwatch = this.$watch("_isLoggedIn", function (newVal) {
                    if (newVal) {
                        this.loadCodeTables();
                        unwatch();
                    }
                });
            }
        },
    };
}
